import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDatepicker, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/shared/material.module';
import { NotificationEventResult } from '../../enums/notification-event-result.enum';

export interface NotificationSectionDate {
  controlName: string;
  labelKey: string;
  hintKey: string;
  showAfterDeadlineError?: boolean;
}

@Component({
  selector: 'app-notification-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatFormField,
    MatLabel,
    MatDatepickerToggle,
    MatDatepicker,
    TranslateModule,
    ReactiveFormsModule,
    MaterialModule,
  ],
  templateUrl: './notification-section.component.html',
  styleUrl: './notification-section.component.scss',
})
export class NotificationSectionComponent {
  form = input.required<FormGroup>();
  titleKey = input.required<string>();
  descriptionKey = input.required<string>();
  recipientsKey = input.required<string>();
  dates = input.required<NotificationSectionDate[]>();
  result = input<NotificationEventResult | null>(null);
  previewDisabled = input(false);

  preview = output<void>();

  readonly NotificationEventResult = NotificationEventResult;

  dateFilter = (date: Date): boolean => {
    const day = date?.getDay();
    return day !== 0 && day !== 6;
  };
}
